import { CardExpiryElement } from '@stripe/react-stripe-js';
import createInput from './utils.js';

const CardExpiryInput = createInput(CardExpiryElement);

export { CardExpiryInput };
